function addToHistory(client,behaviour,params, store, callback) {
  let index = store.clients.findIndex((clientObj) => clientObj.clientID == client.Client);
  console.log("RegisterToHistory store got",behaviour);
  let historyObj = {};
  if(behaviour.FormData) {
    historyObj.Note = JSON.stringify({String: behaviour.FormData.callremarks,Link:null,Reasons:behaviour.FormData.Reasons,CallbackTime:behaviour.FormData.callbackTime});
    historyObj.SegmentJSON = JSON.stringify(behaviour.FormData);
  }
  historyObj.EventTemplate =params.EventTemplate;
  historyObj.Registrant = params.Registrant ;
  historyObj.EventLabel = params.EventLabel;
  historyObj.RootTransactionID = '_FF00321822120916460149925921541158_';
  historyObj.ParentTransactionID = '_FF00321822120916460149925921541158_';
  historyObj.GrantTransactionId = '_FF00321822120916460149925921541158_';
  historyObj.TransactionTemplate =  'ProcessDefaultTemplate-0064-0070';
  historyObj.TransactionTemplateID =  '_FFFFFFFFFFFFFF00001646014960614772_';
  historyObj.ORole = behaviour.Role
  historyObj.OState = behaviour.State;
  historyObj.OAction = behaviour.Action;
  historyObj.OResult = behaviour.Result;
  historyObj.OCycle = behaviour.Cycle;
  historyObj.CState = behaviour.NextState;
  historyObj.OStateQualifier =  behaviour.Role + ":" + behaviour.Action+'/'+behaviour.Result;
  historyObj.BeginTime = (new Date()) .toISOString();
  historyObj.EndTime = (new Date()).toISOString();

  if(index != -1) {
    let GrantPath = JSON.parse(store.clients[index].ClientContext);
    let currentContent = JSON.parse(store.clients[index].CurrentContext);
    console.log("Got Grant data:",GrantPath);
    console.log("Got Grant data:",GrantPath.GrantID);
    console.log("Got current context : ",currentContent);
    console.log("Got current context  attributionid:",currentContent.AttributionID);
    let params = {"ClientID":client.Client,"GrantID":GrantPath.GrantID,"Token":window.LivingScript_0070.guid.generateSync()};
    let registerVal;let that = this;
    historyObj.ClientId = client.Client;
    historyObj.GrantID = GrantPath.GrantID;
    historyObj.Path = "History/Add";
    historyObj.ToPE = GrantPath.GrantPE;
    historyObj.CredentialPE = currentContent.credentialPE;
    historyObj.GatewayPE = currentContent.GatewayPE;
    historyObj.AgentOfPE = currentContent.AgentOfPE;
    historyObj.AttributionId = currentContent.AttributionID;

    $.ajax({
      type:"POST",
      url:"/as/_FFFFFFFFFFFFFF20170326103602132008_/at/_FFFFFFFFFFFFFF20170326103602132008_/module/history-plus/api/register",
      dataType:"json",
      contentType: "application/json",
      data: JSON.stringify({ClientId:client.Client,GrantID:GrantPath.GrantID}),
      success: function(data) {
          console.log("Got HTTP Response Register");
          console.log(data);
          if(data && data.status == "Registration successful") {
              //that.addToHistory(params);
              $.ajax({
                type:"POST",
                url:"/as/_FFFFFFFFFFFFFF20170326103602132008_/at/_FFFFFFFFFFFFFF20170326103602132008_/module/history-plus/api/action",
                data: historyObj,
                dataType:"json",
                success: function(data) {
                    console.log("Got HTTP Response Add");
                    console.log(data);
                    if(callback) {
                      //let historyObj = Object.assign(window.botStore.history,data);
                      callback(null, data);
                    }
                  }
              });
          }
        }
    });
  } else {
    console.log("client does not exist");
  }
}
function SearchHistory(client, token,store, callback) {
  console.log("Search History : ", client,"===",token);

  history.action({
      AttributionId: this.attributionId,
      GrantID : this.grantId,
      Token : this.historyToken,
      ESIndex: "",
      Path: 'History/Search',
      from: 0,
      size: 25,
      scroll_id: null,
      catFilter: [
          [
              {
                  "name": "NoteTemplateID",
                  "value": "_FFFFFFFFFFFFFF00001633127893643639_",
                  "like": false,
                  "notNull": false,
                  "keyword": false
              },
              {
                  "name": "NoteTemplateID",
                  "value": "_FFFFFFFFFFFFFF00001647473012839374_",
                  "like": false,
                  "notNull": false
              },
              {
                  "name": "EventTemplate",
                  "value": "_FFFFFFFFFFFFFF00001590851948799077_",
                  "like": false,
                  "notNull": false,
                  "keyword": false
              }
          ],
          [
              {
                  "name": "ContextPE",
                  "value": params.ContextPE,
                  "like": false,
                  "notNull": false
              },
              {
                  "name": "ContextPE",
                  "value": params.RolePE,
                  "like": false,
                  "notNull": false
              }
          ],    
      ],
      range: [],                        
      where: [],
      ORFilter : [],

      sort: [
          {name: "T1", order: "desc", unmapped_type: "date"},
          {name: "CreationTime", order: "desc", unmapped_type: "date"}
      ]        
  }, (err, res) => {
      //console.log("Search History Out : ", err, res);
      if(res && res.results && res.results.length > 0) {
          console.log("Search History : ", res.results.length);
          let historyRes = res.results.filter((historyItem, index, sefl) => index === sefl.findIndex((item) => item.SourcePK == historyItem.SourcePK ));
          console.log("Search History Filtered : ", historyRes.length);
          callback(null, {Type : 'Inbox', Data : historyRes});
      } else {      
          console.log("Search History : No Results");      
          callback(err, {Type : 'Inbox', Data : []});
      }
  });
}

function getBehaviourHistory(client, store, callback) {
  let index = store.clients.findIndex((clientObj) => clientObj.clientID == client.Client);
  console.log("RegisterToHistory for search store got",client);

  let clientObj = window.top.botStore.getClientByID(client.Client);
  let currentContext = JSON.parse(clientObj.CurrentContext);

  
 /* let historyObj = {  
    GrantId: currentContext.GrantRightID,
    ClientId: client.Client,
    Path: "History/Search",
     "catFilter": [
      [
        {
          "name": "NoteTemplateID",
          "value": "_FFFFFFFFFFFFFF00001633127893643639_",
          "like": false,
          "notNull": false
        },
        {
          "name": "NoteTemplateID",
          "value": "_FFFFFFFFFFFFFF00001647473012839374_",
          "like": false,
          "notNull": false
        }
      ],
      [
        {
          "name": "ContextPE",
          "value": "11admin1_FFFFFFFFFFFFFF00001567723986493004_1holder1_FFFFFFFFFFFFFF00001567723986493005_",
          "like": false,
          "notNull": false
        },
        {
          "name": "ContextPE",
          "value": "11holder1_FFFFFFFFFFFFFF00001567723986493005_1holder1_FFFFFFFFFFFFFF00001567723986493005_",
          "like": false,
          "notNull": false
        }
      ],
      
    ],
  "where": [
      {
          "name": "HistoryItem.ByRight",
          "value": "1_FFFFFFFFFFFFFF00001567723986493005_",
          "like": false,
          "notNull": false
        },
       {
          "name": "HistoryItem.ToRight",
          "value": "1_FFFFFFFFFFFFFF00001567723986493005_",
          "like": false,
          "notNull": false
        }
  ],
/*  "ORFilter": [
      [
        
      [
        {
          "name": "HistoryItem.ByPE",
          "value": "11admin1_FFFFFFFFFFFFFF00001567723986493004_1holder1_FFFFFFFFFFFFFF00001567723986493005_",
          "like": false,
          "notNull": false
        },
        {
          "name": "HistoryItem.ToPE",
          "value": "11holder1_FFFFFFFFFFFFFF00001567723986493005_1holder1_FFFFFFFFFFFFFF00001567723986493005_",
          "like": false,
          "notNull": false
        }
      ],
      [
        {
          "name": "HistoryItem.ToPE",
          "value": "11admin1_FFFFFFFFFFFFFF00001567723986493004_1holder1_FFFFFFFFFFFFFF00001567723986493005_",
          "like": false,
          "notNull": false
        },
        {
          "name": "HistoryItem.ByPE",
          "value": "11holder1_FFFFFFFFFFFFFF00001567723986493005_1holder1_FFFFFFFFFFFFFF00001567723986493005_",
          "like": false,
          "notNull": false
        }
      ],
      
    ],
    "sort": [
      {
        "name": "UpdateTime",
        "order": "desc"
      }
    ],
    "range": [
      {
        "value1": "imad903@imad903.com",
        "value2": "",
        "name": "HistoryItem.ByLeft"
      }
    ],
     "from": 0,
    "size": 25,
    "scripts": [
       {
          “script”: “return doc['ByPE'].value == doc['ReachableContextPE'].value;”
        }
    ],
    “OSParams”: {
  "aggs": {
      "types_count": {
        "value_count": {
          "field": "HistoryItem.PK"
        }
      }
    
    }
    }*/
  //};

  /*if(behaviour.FormData) {
    historyObj.Note = JSON.stringify({String: behaviour.FormData.callremarks,Link:null,Reasons:behaviour.FormData.Reasons,CallbackTime:behaviour.FormData.callbackTime});
    historyObj.SegmentJSON = JSON.stringify(behaviour.FormData);
  }
  //historyObj.EventTemplate =params.EventTemplate;
  //historyObj.Registrant = params.Registrant ;
  //historyObj.EventLabel = params.EventLabel;
  historyObj.RootTransactionID = '_FF00321822120916460149925921541158_';
  historyObj.ParentTransactionID = '_FF00321822120916460149925921541158_';
  historyObj.GrantTransactionId = '_FF00321822120916460149925921541158_';
  historyObj.TransactionTemplate =  'ProcessDefaultTemplate-0064-0070';
  historyObj.TransactionTemplateID =  '_FFFFFFFFFFFFFF00001646014960614772_';
  //historyObj.ORole = behaviour.Role
  //historyObj.OState = behaviour.State;
  //historyObj.OAction = behaviour.Action;
  //historyObj.OResult = behaviour.Result;
  //historyObj.OCycle = behaviour.Cycle;
  //historyObj.CState = behaviour.NextState;
  //historyObj.OStateQualifier =  behaviour.Role + ":" + behaviour.Action+'/'+behaviour.Result;
  //historyObj.BeginTime = (new Date()) .toISOString();
  //historyObj.EndTime = (new Date()).toISOString();
*/
  if(index != -1) {
    let GrantPath = JSON.parse(store.clients[index].ClientContext);
    let currentContent = JSON.parse(store.clients[index].CurrentContext);
    console.log("Got Grant data:",GrantPath);
    console.log("Got Grant data:",GrantPath.GrantID);
    console.log("Got current context : ",currentContent);
    console.log("Got current context  attributionid:",currentContent.AttributionID);
    let params = {"ClientID":client.Client,"GrantID":GrantPath.GrantID,"Token":window.LivingScript_0070.guid.generateSync()};
    let registerVal;let that = this;
  /*  historyObj.ClientId = client.Client;
    historyObj.GrantID = GrantPath.GrantID;
    historyObj.Path = "History/Search";
    historyObj.ToPE = GrantPath.GrantPE;
    historyObj.CredentialPE = currentContent.credentialPE;
    historyObj.GatewayPE = currentContent.GatewayPE;
    historyObj.AgentOfPE = currentContent.AgentOfPE;
    historyObj.AttributionId = currentContent.AttributionID;
*/
    let token = window.top.LivingScript_0070.guid.generateSync();
    $.ajax({
      type:"POST",
      url:"/as/_FFFFFFFFFFFFFF20170326103602132008_/at/_FFFFFFFFFFFFFF20170326103602132008_/module/history-plus/api/register",
      dataType:"json",
      contentType: "application/json",
      data: JSON.stringify({ClientId:client.Client,GrantID:GrantPath.GrantID,Token : token}),
      success: function(data) {
          console.log("Got HTTP Response Register");
          console.log(data);
          if(data && data.status == "Registration successful") {
            SearchHistory(client, token,store, callback);
              //that.addToHistory(params);
             /* $.ajax({
                type:"POST",
                url:"/as/_FFFFFFFFFFFFFF20170326103602132008_/at/_FFFFFFFFFFFFFF20170326103602132008_/module/history-plus/api/action",
                data: historyObj,
                dataType:"json",
                success: function(data) {
                    console.log("Got HTTP Response Search");
                    console.log(data);
                    if(callback) {
                      //let historyObj = Object.assign(window.botStore.history,data);
                      callback(null, data);
                    }
                  }
              });*/
          }
        }
    });
  } else {
    console.log("client does not exist");
  }
}

export {
  addToHistory,
  getBehaviourHistory
}
